import * as actionType from "../constants";
export const enableMonitoring = () => async (dispatch) => {
  try {
    dispatch({ type: actionType.ENABLE_MONITORING });
  } catch (error) {
    console.log(error);
  }
};
